import React from 'react'

function CardComplementary() {
  return (
    <div className="container">
        <h4 className="mb-5">Servicios complementarios</h4>
  <div className="row">
    <div className="col-12 col-md-6 mb-4">
      <div className="card card-horizontal">
        <div className="card-body">
          <h3 className="card-title">
            <a href="https://ciudad3d.buenosaires.gob.ar/" target="_blank" rel="noopener noreferrer" className="card-title-link">Ciudad 3D</a>
          </h3>
          <p className="card-text">Visualizá en 3D qué se puede construir en cada barrio de la Ciudad de Buenos Aires</p>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-6 mb-4"> 
      <div className="card card-horizontal">
        <div className="card-body">
          <h3 className="card-title">
            <a href="https://data.buenosaires.gob.ar/" target="_blank" rel="noopener noreferrer" className="card-title-link">BA Data</a>
          </h3>
          <p className="card-text">Plataforma que actúa como un gran repositorio de los datos que genera y disponibiliza el Gobierno de la Ciudad</p>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-6 mb-4">
      <div className="card card-horizontal">
        <div className="card-body">
          <h3 className="card-title">
            <a href="http://www.ssplan.buenosaires.gov.ar/webfiles/mapaoficial.php" target="_blank" rel="noopener noreferrer" className="card-title-link">PDI</a>
          </h3>
          <p className="card-text">Consultá el mapa para informate acerca de toda obra iniciada o próxima a iniciarse en el área de tu interés</p>
        </div>
      </div>
    </div>
    <div className="col-12 col-md-6 mb-4">
      <div className="card card-horizontal">
        <div className="card-body">
          <h3 className="card-title">
            <a href="https://www.estadisticaciudad.gob.ar/eyc/?page_id=35782" target="_blank" rel="noopener noreferrer" className="card-title-link">Banco de datos DGEyC</a>
          </h3>
          <p className="card-text">Actividades estadisticas oficiales y realización de censos que se efectúan en el territorio de la Ciudad</p>
        </div>
      </div>
    </div>
  </div>
</div>
  )
}

export default CardComplementary